import React, { useEffect, useState } from 'react';
import { CreateFeatureDialog } from 'components';
import { useNavigate, useLocation } from 'react-router-dom';
import { GLOSSARY_METADATA_PATHS } from '../../../../constants/glossary-metadata-paths';
import { usePermission } from '../../../../core';
import { createGlossaryMenuItems } from '../../glossary-metadata-helper';

export const CreateGlossaryView = (): React.JSX.Element => {
    const navigate = useNavigate();
    const location = useLocation();
    const { hasPermissions } = usePermission();
    const [selectedOption, setSelectedOption] = useState<string>(
        GLOSSARY_METADATA_PATHS.CREATE_NEW_GLOSSARY_METADATA
    );
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);

    const glossaryQueryParams = new URLSearchParams(location.search);
    const glossaryOption = glossaryQueryParams.get('option');

    useEffect(() => {
        if (glossaryOption) {
            const selectedTab = createGlossaryMenuItems.find(
                (item) => `${item.title}` === glossaryOption
            );
            if (selectedTab) {
                setSelectedOption(selectedTab?.navigationPath);
            }
        }
    }, [glossaryOption]);

    const handleNoGlossaryCreationPermission = (): void => {
        setDisplayPermissionDialog(true);
    };

    const handleNext = (): void => {
        const permission = hasPermissions('createMetadata');
        if (permission && selectedOption) {
            navigate(selectedOption);
        } else if (!permission) {
            handleNoGlossaryCreationPermission();
        }
    };

    const handleClose = (): void => {
        navigate(`${GLOSSARY_METADATA_PATHS.LANDING_PAGE}`);
    };

    const handlePermissionDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <CreateFeatureDialog
            items={createGlossaryMenuItems}
            handleNext={handleNext}
            handleClose={handleClose}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            displayPermissionDialog={displayPermissionDialog}
            handlePermissionDialogClose={handlePermissionDialogClose}
            headingText={'What would you like to create?'}
        />
    );
};
